import { IFormData, ValidFieldTypes } from '../types';
import { formatExpDate } from './date';

const getFieldValue = {
  [ValidFieldTypes.CARD_NUMBER]: (fieldValue) => fieldValue?.replaceAll(/[ x_]/g, ''),
  [ValidFieldTypes.EXPIRATION_DATE]: (fieldValue) => fieldValue ? formatExpDate(fieldValue) : '',
  [ValidFieldTypes.ACCOUNT_NUMBER]: (fieldValue) => fieldValue?.replaceAll(/[ x]/g, ''),
};

export const prepareData = (formData: IFormData): Partial<IFormData> => {
  const result: Record<string, string> = {};

  Object.entries(formData).forEach(([field, fieldValue]) => {
    if (getFieldValue[field]) {
      result[field] = getFieldValue[field](fieldValue);
    } else {
      result[field] = fieldValue;
    }
  });

  return result;
};
